import React from 'react';
import moment from 'dayjs';

function ReceiptURL(url) {
  if(!url) {
    return
  }

  return <div className="membership-receipt">- <a href={url} className="link-text" target="_black">See receipt</a></div>
}

export function BillingListItem({ billingList }) {
  const str = billingList.amount.toString()
  const amountCharged = str.slice(0, -2) + "."+ str.slice(-2)
  // A charge made through a PaymentIntent (e.g. after 3-D Secure) has no source; its card is
  // under payment_method_details.card. Prefer source when it has a brand: its brand is the display
  // name ("Visa"), while payment_method_details uses lowercase codes ("visa").
  const card = billingList.source?.brand ? billingList.source : billingList.payment_method_details?.card

  return (
    <div>
      <small>
        <b>{moment.unix(billingList.created).format('MMM DD, YYYY')}</b> ${amountCharged}{card ? <> on {card.brand} card ending with {card.last4}</> : null} {ReceiptURL(billingList.receipt_url)}
      </small>
    </div>
  )
}